<template>
  <div>
    <button type="submit" class="btn btn-primary" @click="isModalOpen=true">Добавить</button>

    <u-modal id="createServer" link="Добавить хост в проект" title="Добавить хост в проект" :isModalOpen="isModalOpen">
      <form @submit.prevent="createDomain">
        <u-form-input type="text" v-model="formData.domain" id="domain" name="Домен (ya.ru)"/>
        <u-form-input type="text" v-model="formData.pingUrl" id="pingUrl" name="Адрес для пинга (https://ya.ru/robots.txt)"/>
        <button type="submit" class="btn btn-primary">Добавить</button>
      </form>
    </u-modal>
  </div>
</template>

<script setup>
import {defineProps, ref, defineEmits} from 'vue'
import {useDomainStore} from "@/store/domains";

const props  = defineProps({
  serviceId: String,
})

const domainStore = useDomainStore()


const formData = ref({})
const isModalOpen = ref(false)

const emit = defineEmits(['domainId'])
function createDomain () {
  domainStore.create({...formData.value, serviceId: props.serviceId})
      .then((domain) => {
        domainStore.getList({serviceId: props.serviceId})
        emit('domainId', domain.id)
        isModalOpen.value = false
      })
}
</script>
